<template>
  <div id="login_page_container">
    <div id="login_page">
    <router-link to="/">חזרה לדף הבית</router-link>
      <h2 class="title">כניסת עורכי דין / יזמים</h2>
      <form @submit.prevent="login" v-if="show_page=='login'">
      
        <ul class="frmUL">
          <li>
              <label>כתובת מייל איתה נרשמת</label>
              <input type="text" v-model="username" name="username" required="">
              <!-- <span class="md-helper-text">הזן כתובת מייל או טלפון נייד</span> -->
          </li>
      
          <li>
              <label>סיסמה</label>
              <input type="password" name="password" v-model="password" required="">
              <!-- <span class="md-helper-text">הזן את הסיסמה שלך</span> -->
          </li>
        </ul>
          <!-- <md-checkbox v-model="remember_me" value="1" class="md-primary">Remember me</md-checkbox> -->
      
      
          <div class="bottom_links"><a @click="show_page='forgot'">שכחתי סיסמה</a></div>
          <input class="btn" type="submit" value="התחברות">
      
      </form>
      <ForgotPassword v-if="show_page=='forgot'" />
      <div class="join">
        <div class="text">
          <p class="title">עדיין לא הצטרפת? ההרשמה ללא עלות!</p>
          <p>לחיצה על הכפתור ונתחיל בהרשמה</p>
        </div>
        <div class="btns">
          <a @click="$emit('signup', 'entrepreneur')">אני יזם</a>
          <a @click="$emit('signup', 'lawyer')">אני עו"ד</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ForgotPassword from '@/components/ForgotPassword.vue';
export default {
  components: { ForgotPassword},
  data(){
      return {
        forgotUrl: window.api_url + 'signup/forgotPass',
        FB: {},
        model: {},
        scope: {},

        token: '',
        show_step_b: false,
        is_loading: false,
        username: '',
        password: '',
        remember_me: false,
        
        show_page: this.$route.path == '/signup' ? 'signup' :'login',

        accept_terms: false,

        signupForm: { 
          display_name: '',
          username: '',
          password: ''
        },

        forgotForm: {
          email: ''
        }
      }
  },
  mounted(){
      
    if (!this.is_mobile()) document.querySelector('input').focus()

  },
  methods:{
    login(){
      this.is_loading = true;


      const formData = { 
        password: this.password,
        username: this.username 
      };

      this.api({ 'action': 'login', data: formData}, (data) => {
        
          if (this.isNull(data) || this.isNull(data.data?.token))
          {
              this.is_loading = false;
              this.alert('הפרטים שהזנת אינם נכונים. אנא נסה שנית.');
          }
          else
          {
              this.set_user_token(data.data?.token);
              // if (this.isApp) this.afterLogin();
            let url = "";
            if (data.data.userType === "entrepreneur") {
              url = "/list"
            }
            if (data.data.userType === "lawyer") {
              url = "/projects_manager"
            }
            this.$bus.$emit('reload', url);
          }
          
      });

    },

    signup(){
      this.is_loading = true;

      if (!this.accept_terms) return false;

      this.api({ 'action': 'signup', data: this.signupForm}, (data) => {
        
          if (this.isNull(data) || this.isNull(data.data))
          {
              this.is_loading = false;
              this.alert("הפרטים אינם נכונים");
          }
          else if(data.data == "exist")
          {
              this.is_loading = false;
              this.alert("אימייל זה תפוס אנא נסו אימייל אחר או עברו לעמוד התחברות");
          }
          else
          {
    
            this.set_user_token(data.data.token);
            if (this.isApp) this.afterLogin();
            this.$bus.$emit('reload');
          }
          
      });

    },

    forgot(){
      this.is_loading = true;

      this.api({ 'action': 'forgot_password', data: this.forgotForm}, (data) => {
        
        this.is_loading = false;

        if (data.data === true)
        {
          this.alert(this.get_word('forgot_pass_step1_finish'))
        }
        else
        {
          this.alert('משתמש לא נמצא');
        }
          
      });

    },    

    afterLogin(){
			if (!this.isIOS)
			{
				var permissions = cordova.plugins.permissions;
				permissions.requestPermission(permissions.POST_NOTIFICATIONS, () => {
					
					cordova.plugins.firebase.messaging.subscribe("main");
				
					cordova.plugins.firebase.messaging.getToken().then((token) => {
						
						this.api({ 'action': 'user/set_push_token', data: {'token': token}});
					});
				});
			}
			else
			{
				cordova.plugins.firebase.messaging.requestPermission({forceShow: true}).then(() => {

					cordova.plugins.firebase.messaging.subscribe("main");
				
					cordova.plugins.firebase.messaging.getToken().then((token) => {
					
						this.api({ 'action': 'user/set_push_token', data: {'token': token}});
					});
					
				});
			}

    },
    login_fb(){

      if (this.isApp)
      {
        window.login_fb();
      }
      else
      {
        document.location = window.api_url + '/cfacebook/login';
      }
      
    },
    login_g(){
      if (this.isApp)
      {
        window.plugins.googleplus.isAvailable((avail) => {
          if(avail){
                window.plugins.googleplus.login(
                    {
                        'webClientId': '143552653315-6cd963on602mdptondbh99n7bv5sdni4.apps.googleusercontent.com',
                        'offline': false
                    },
                     (obj) => {
                       this.api({ action: 'google', data: obj}, (data) =>{
                        if(data.data && !this.isNull(data.data))
                        {
                            this.set_user_token(data.data);
                            if (this.isApp) this.afterLogin();
                            this.$bus.$emit('reload');
                        }
                      });
                    },
                     () => {
                        this.alert("ההתחברות נכשלה נא לנסות באמצעי אחר");
                    }
                );
            }
        });
      }
      else
      {
        document.location = window.api_url + 'google_login';
      }
    },
    loginApple(){
      if (this.isIOS)
      {
        cordova.plugins.SignInWithApple.signin({ requestedScopes: [0, 1] },
          (succ) =>{
            this.api({ action: 'apple', data: succ}, (data) =>{
                  if(data.data && !this.isNull(data.data))
                  {
                      this.set_user_token(data.data);
                      if (this.isApp) this.afterLogin();
                      this.$bus.$emit('reload');
                  }
                  else{
                      this.alert("ההתחברות נכשלה נא לנסות באמצעי אחר");
                  }
                  
                });
          },
          function(){
            this.alert("ההתחברות נכשלה נא לנסות באמצעי אחר");
          }
        );
      }
    
    },

  }
}
</script>

<style lang="scss" scoped>
#login_page_container{width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;}
#login_page {display: flex;  flex-direction: column; gap: 100px;    min-width: 450px;

  h2.title {text-align: center;}
  .join { display: flex; flex-direction: column; gap: var(--gap_big);
    .text {
      .title {font-size: 22px; color: var(--title_color);}
      p {font-size: 18px; color: var(--title_color);}
    }
    .btns {width: 100%; display: flex; gap: 30px;
      a { flex: 1; height: 50px; display: flex; align-items: center; justify-content: center; border: 1px solid var(--text_s); color: var(--title_color); border-radius: 16px;
        &:hover {background: var(--text_s); color: #fff;}
      }
    }
  }
  
  .fb_btn, .g_btn,.apple_btn { text-align: center; width: 100%; height: 48px; line-height: 48px; border-radius: 6px; display: inline-block; color: #fff !important;   font-size: 16px; padding: 0 15px; padding-left: 41px; margin-bottom: 15px;  }
  .fb_btn { background: #30487b /*url(../images/f_ico.png)*/ 10px center no-repeat; }
  .g_btn {  background: #f14338 /*url(../images/f_ico.png)*/ 10px center no-repeat; }
  .apple_btn {  background: #c9c9c9 /*url(../images/f_ico.png)*/ 10px center no-repeat;color: #000 !important; }
  
  .border_title { color: #A2A2A2; font: 23px sans-serif;  margin-top: 30px; text-align: center; position: relative; z-index: 1; margin: 15px 0px;    
    span { background: #fff; padding: 0 15px; }
    &::before { border-top: 2px solid #dfdfdf; content: ""; margin: 0 auto; position: absolute; top: 50%; left: 0; right: 0; bottom: 0; width: 95%; z-index: -1; }
  }
  
  .bottom_links {  width: 100%; display:flex; justify-content: flex-end; margin-bottom: 40px;
    a { color: #333 !important; text-decoration: underline;}
  }
  // input[type=submit] {
  //   width: 100%; border-radius: var(--radius); background: var(--green_light); height: 50px; display: flex; align-items: center;justify-content: center; font-size: 18px;
  // font-weight: 700;
  // }
}

</style>